import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history"
import { CircularProgress } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { index } from './store/actions/app.action'

const Auth = lazy(() => import('./view/auth'))
const VerifyDevice = lazy(() => import('./view/auth/verify-device'))
const TwoFaMethod = lazy(() => import('./view/auth/2fa-method'))

const Users = lazy(() => import('./view/desktop/users'))
const Profile = lazy(() => import('./view/desktop/users/profile'))
const WhatsappList = lazy(() => import('./view/desktop/whatsapp-list'))
const Accounts = lazy(() => import('./view/desktop/accounts'))
const EditAccount = lazy(() => import('./view/desktop/accounts/edit'))
const PaymentAvailable = lazy(() => import('./view/desktop/accounts/available'))

const Shopping = lazy(() => import('./view/desktop/shopping'))
const Campaigns = lazy(() => import('./view/desktop/campaigns'))
const Closed = lazy(() => import('./view/desktop/campaigns/closed'))
const Trash = lazy(() => import('./view/desktop/campaigns/trash'))
const EditCampaign = lazy(() => import('./view/desktop/campaigns/edit'))
const RaffleCampaign = lazy(() => import('./view/desktop/campaigns/raffle'))
const Smaller = lazy(() => import('./view/desktop/smaller'))
const Top = lazy(() => import('./view/desktop/top'))
const Consult = lazy(() => import('./view/desktop/consult'))
const Metrics = lazy(() => import('./view/desktop/metrics'))
const MetricsRegion = lazy(() => import('./view/desktop/metrics/region'))
const ChartCampaigns = lazy(() => import('./view/desktop/campaigns/chart'))
const ChartCampaign = lazy(() => import('./view/desktop/campaigns/chart/campaign'))

const ChartLinks = lazy(() => import('./view/desktop/links/chart'))
const ChartLink = lazy(() => import('./view/desktop/links/chart/link'))

const ChartAccount = lazy(() => import('./view/desktop/accounts/chart'))
const ChartAfiliado = lazy(() => import('./view/desktop/afiliados/chart'))
const ChartGestor = lazy(() => import('./view/desktop/gestor/chart'))

const Links = lazy(() => import('./view/desktop/links'))
const EditLink = lazy(() => import('./view/desktop/links/edit'))
const Transactions = lazy(() => import('./view/desktop/transactions'))
const Awarded = lazy(() => import('./view/desktop/awarded'))
const EditAwarded = lazy(() => import('./view/desktop/awarded/edit'))
const Roulette = lazy(() => import('./view/desktop/roulette'))
const EditRoulette = lazy(() => import('./view/desktop/roulette/edit'))
const Pixel = lazy(() => import('./view/desktop/pixel'))
const EditPixel = lazy(() => import('./view/desktop/pixel/edit'))
const Utms = lazy(() => import('./view/desktop/utms'))
const Google = lazy(() => import('./view/desktop/google'))
const EditGoogle = lazy(() => import('./view/desktop/google/edit'))
const Capitalizer = lazy(() => import('./view/desktop/capitalizer'))
const Theme = lazy(() => import('./view/desktop/theme'))
const Secure = lazy(() => import('./view/desktop/secure'))
const Password = lazy(() => import('./view/desktop/password'))
const Webhook = lazy(() => import('./view/desktop/webhooks'))
const EditWebhook = lazy(() => import('./view/desktop/webhooks/edit'))
const Afiliados = lazy(() => import('./view/desktop/afiliados'))
const EditAfiliados = lazy(() => import('./view/desktop/afiliados/edit'))
const PasswordAfiliados = lazy(() => import('./view/desktop/afiliados/password'))
const AccessAfiliados = lazy(() => import('./view/desktop/afiliados/access'))

const Gestores = lazy(() => import('./view/desktop/gestor'))
const EditGestor = lazy(() => import('./view/desktop/gestor/edit'))
const PasswordGestor = lazy(() => import('./view/desktop/gestor/password'))
const AccessGestor = lazy(() => import('./view/desktop/gestor/access'))

const Prizes = lazy(() => import('./view/desktop/instant-prizes'))
const EditPrize = lazy(() => import('./view/desktop/instant-prizes/edit'))

const Routes = () => {
    const history = createBrowserHistory()
    const [loading, setLoading] = React.useState(true)
    const dispatch = useDispatch()
    

    React.useEffect(() => {
        if(history.location.pathname !== '/login') {
            dispatch(index()).then(res => res && setLoading(false))
        }else {
            setLoading(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
        {(history.location.pathname !== '/login' && loading ) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
        <Router>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center min-vh-100"> <CircularProgress/> </div>}>
                <Switch>
                    <Route exact path="/afiliados/:afiliado_id/metrics" component={Metrics} />
                    <Route exact path="/afiliados/:afiliado_id/metrics/region" component={MetricsRegion} />
                    <Route exact path="/afiliados/create" component={EditAfiliados} />
                    <Route exact path="/afiliados/:id/acesso" component={AccessAfiliados} />
                    <Route exact path="/afiliados/:id/edit" component={EditAfiliados} />
                    <Route exact path="/afiliados/:id/password" component={PasswordAfiliados} />
                    <Route exact path="/afiliados" component={Afiliados} />

                    <Route exact path="/gestor/create" component={EditGestor} />
                    <Route exact path="/gestor/:id/acesso" component={AccessGestor} />
                    <Route exact path="/gestor/:id/edit" component={EditGestor} />
                    <Route exact path="/gestor/:id/password" component={PasswordGestor} />
                    <Route exact path="/gestores" component={Gestores} />
                    <Route exact path="/consult/:campaign_id" component={Consult} />
                    <Route exact path="/top/:campaign_id" component={Top} />
                    <Route exact path="/awarded/:campaign_id/create/:editor?" component={EditAwarded} />
                    <Route exact path="/awarded/:campaign_id/:id/edit/:editor?" component={EditAwarded} />
                    <Route exact path="/awarded/:campaign_id/:editor?" component={Awarded} />

                    <Route exact path="/instant-prizes/:campaign_id/create/:editor?" component={EditPrize} />
                    <Route exact path="/instant-prizes/:campaign_id/:id/edit/:editor?" component={EditPrize} />
                    <Route exact path="/instant-prizes/:campaign_id/:editor?" component={Prizes} />

                    <Route exact path="/roulette/:campaign_id" component={Roulette} />
                    <Route exact path="/roulette/:campaign_id/create" component={EditRoulette} />
                    <Route exact path="/roulette/:campaign_id/:id/edit" component={EditRoulette} />
        
                    <Route exact path="/webhooks/create" component={EditWebhook} />
                    <Route exact path="/webhooks/:id/edit" component={EditWebhook} />
                    <Route exact path="/webhooks" component={Webhook} />

                    <Route exact path="/pixel/create" component={EditPixel} />
                    <Route exact path="/pixel/:id/edit" component={EditPixel} />
                    <Route exact path="/pixel" component={Pixel} />
                    <Route exact path="/utms" component={Utms} />
                    <Route exact path="/google-tag-manager/create" component={EditGoogle} />
                    <Route exact path="/google-tag-manager/:id/edit" component={EditGoogle} />
                    <Route exact path="/google-tag-manager" component={Google} />
                    <Route exact path="/links/:campaign_id/create" component={EditLink} />
                    <Route exact path="/links/:campaign_id/:id/edit" component={EditLink} />
                    <Route exact path="/links/:campaign_id/:link_id/transactions" component={Transactions} />
                    <Route exact path="/links/:campaign_id/:link_id/metrics" component={Metrics} />

                    <Route exact path="/gateway-payment/:account_id/analysis" component={ChartAccount} />
                    <Route exact path="/afiliados/:afiliado_id/analysis" component={ChartAfiliado} />
                    <Route exact path="/gestores/:gestor_id/analysis" component={ChartGestor} />

                    <Route exact path="/links/:campaign_id/analysis" component={ChartLinks} />
                    <Route exact path="/links/:campaign_id/:link_id/analysis" component={ChartLink} />

                    <Route exact path="/links/:campaign_id" component={Links} />
                    <Route exact path="/campaigns/create" component={EditCampaign} />
                    <Route exact path="/campaigns/:campaign_id/edit" component={EditCampaign} />
                    <Route exact path="/campaigns/:campaign_id/raffle" component={RaffleCampaign} />
                    <Route exact path="/campaigns/:campaign_id/smaller" component={Smaller} />
                    <Route exact path="/campaigns/analysis" component={ChartCampaigns} />
                    <Route exact path="/campaigns/:campaign_id/analysis" component={ChartCampaign} />
                    <Route exact path="/campaigns/:campaign_id/metrics/region" component={MetricsRegion} />
                    <Route exact path="/campaigns/:campaign_id/transactions" component={Transactions} />
					<Route exact path="/campaigns/closed" component={Closed} />
                    <Route exact path="/campaigns/trash" component={Trash} />
                    <Route exact path="/campaigns" component={Campaigns} />
                    <Route exact path="/shopping/:user_id/transactions/:campaign_id" component={Transactions} />
                    <Route exact path="/shopping/:user_id" component={Shopping} />
                    <Route exact path="/gateway-payment/:id/edit" component={EditAccount} />
                    <Route exact path="/gateway-payment/create/:gateway" component={EditAccount} />
                    <Route exact path="/gateway-payment" component={Accounts} />
                    <Route exact path="/gateway-payment/available" component={PaymentAvailable} />
                    <Route exact path="/supporters/:user_id/profile" component={Profile} />
                    <Route exact path="/supporters" component={Users} />
                    <Route exact path="/whatsapp-list" component={WhatsappList} />
                    <Route exact path="/password" component={Password} />
                    <Route exact path="/capitalizer" component={Capitalizer} />
                    <Route exact path="/theme" component={Theme} />
                    <Route exact path="/secure" component={Secure} />
                    <Route exact path="/login" component={Auth} />
                    <Route exact path="/2fa/verify/:method" component={VerifyDevice} />
                    <Route exact path="/2fa/method" component={TwoFaMethod} />
                    <Route exact path="/" component={Campaigns} />
                </Switch>
            </Suspense>
        </Router>
        }
        </>
    )
}

export default Routes;